// Core
import { Box, Flex, Grid, Text, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import Card from 'components/Card/Card';

const Prizes = ({userData}) => { 
	const { colorMode, toggleColorMode } = useColorMode();
  	const isDark = colorMode === 'dark';

	const styleHeader = {
		color: '#099BFF',
		textAlign: 'center',
		fontSize: '18px',
		fontStyle: 'italic',
		fontWeight: '800',
		lineHeight: 'normal',
		textTransform: 'uppercase'
	};

	const styleCard = {
		padding: '16px',
		textAlign: 'center',
    	position: 'relative',
    	border: '1px solid #2ABDFD',
    	overflow: 'hidden',
    	background: 'transparent'
	};

	return (
		<Grid mt="18px" rowGap="10px" templateColumns={{ sm: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="16px" templateRows='1fr'>
			<Card style={styleCard}>
				{ isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader}>
		    		Current Entries
		    	</Text>
		    	<Text variant="title-md" py="8px" fontSize="28px" fontStyle="italic" fontWeight="800">{userData?.entries}</Text>
		    	<Text 
		    		variant="title-md"
		    		fontStyle="italic"
					textTransform="uppercase" 
		    		color="#9FABCB">Entries</Text>
		    </Card>

		    <Card style={styleCard}>
		    	{ isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader}>
		    		Prize value of upcoming prizes
		    	</Text>
		    	<Text pt="8px" variant="title-md" fontSize="28px" fontStyle="italic" fontWeight="800">
		    		$1,000,000
		    	</Text>
		    </Card>

		    <Card style={styleCard}>
		        { isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader}>
		    		Prize value of current prizes
		    	</Text>
		    	<Text pt="8px" variant="title-md" fontSize="28px" fontStyle="italic" fontWeight="800">
		    		$800,000
		    	</Text>
		    </Card>
		</Grid>
	);
};

export default Prizes;